import {Injectable, OnDestroy} from '@angular/core';
import * as globals from '../../settings';
import {UserService} from '../../_services/user.service';
import {LotteriesService} from '../../lotteries.service';
import {LoginService} from '../navigation/login.service';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetPaymentMethodsService implements OnDestroy {
  gpm_tmp: any;
  time: number;
  oldTime: number;
  getGPMtimeSub: Subscription;
  getLogout: Subscription;
  pmsCounter: number;

  constructor(public userService: UserService,
              public lotteryService: LotteriesService,
              private loginService: LoginService,
              public subscriptionsService: SubscriptionsService) {
    this.userService.getUser();

    this.getGPMtimeSub = this.subscriptionsService.getGPMserviceTimestamp().subscribe(time => {
      this.oldTime = time;
    });

    this.getLogout = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
      if (data === false) {
        this.gpm_tmp = false;
      }
    });
  }

  getPaymentMethods() {
    return new Promise(resolve => {
      const howOften = 1; /* how often (in seconds) script can call endpoint? */
      this.time = Math.round(Date.now() / (howOften * 1000));
      if (this.userService &&
        this.userService.userData &&
        this.userService.userData.sessionId) {
        if (this.time !== this.oldTime) {
          const sendData = {};
          let memberId;
          sendData['sessionId'] = this.userService.userData.sessionId;
          if (this.userService &&
            this.userService.userData &&
            this.userService.userData.memberId) {
            memberId = this.userService.userData.memberId;
          } else {
            memberId = 0;
          }
          this.lotteryService.postData(
            globals.appDomain + '/payments/getPaymentMethods/' +
            memberId + '/getPaymentMethods_service.json', this.loginService.getFormUrlEncoded(sendData))
            .subscribe(
              result => {
                if (result.message && !result.message.DepositAmounts) {
                  result.message.DepositAmounts = JSON.parse('{"firstValue": 20, "secondValue": 50, "thirdValue": 100}');
                }
                this.subscriptionsService.emitGetPaymentMethods(result);
                this.gpm_tmp = result;
                resolve('GPM');
                if (result && result.message && result.message.PaymentOptions) {
                  this.pmsCounter = result.message.PaymentOptions.length;
                } else {
                  this.pmsCounter = 0;
                }
              }
            );
          this.subscriptionsService.updateGPMserviceTimestamp(this.time);
        } else {
          this.subscriptionsService.emitGetPaymentMethods(this.gpm_tmp);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.getGPMtimeSub) {
      this.getGPMtimeSub.unsubscribe();
    }
  }
}
